<template>
  <div class="video-box">
  </div>
</template>
<script>
export default {
  name: 'TestPage',
  data () {
    return {
    }
  },
  methods: {
  },
  beforeCreate () {},
  created () {},
  mounted () {

  }
}
</script>
<style scoped lang="scss">
  @import "./../assets/styles/common/functions";
  .test-page{
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/TestPage.vue